<template>
  <div class="header_bottom_seven" style="background-color: #2e67ae;">
    <div class="container-full">
      <div class="row align-items-center px-0">
        <div class="col-lg-12">
          <div class="main_menu menu_seven header_position">
            <nav>
              <ul>

                <li class="active nav-item dropdown" @mouseover="() => {hideallless(), show_collection = true}">
                  <a href="#" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false" class="menu-hover">
                    <strong>Coleções</strong>
                    <span class="ms-2">
                      <img src="/img/newsIcons/SETA_CATEGORIAS.webp" alt="" style="width: 20px;"
                        class="dropdown-trigger mb-1">
                    </span>
                  </a>

                </li>
                <!-- Dropdown menu personalizado -->
                <div :class="show_collection ? 'show' : ''" @mouseleave="show_collection = false"
                  class="dropdown-menu border border-2 border-top-0 rounded-0 rounded-bottom py-0 m-auto w-100"
                  aria-labelledby="dropdownMenu2">
                  <div class="row">

                    <div
                      class="col-20 row d-flex align-items-center justify-content-center border border-1 border-light p-1 py-2"
                      v-for="child_category in collection_categories" :key="child_category.id">
                      <div class="col-4 p-2">
                        <a :href="'/product/list/' + child_category.id">
                          <img v-if="child_category?.image.length < 35" :src="'/img/icon/notfoundcategory.png'"
                            class="img-fluid h-auto w-75">
                          <img v-else :src="child_category?.image || '/img/icon/notfoundcategory.png'"
                            class="img-fluid h-auto">
                        </a>
                      </div>

                      <div class="col-8 text-chumbo">
                        <h6 class="fw-bold text-uppercase"><a :href="'/product/list/' + child_category.id"><strong>{{ child_category.name
                        }}</strong></a></h6>
                      </div>
                    </div>

                    <div class="col-20 row d-flex align-items-center justify-content-center border border-1 border-light p-1">
                      <div class="col-3 p-2">
                        <a :href="'/collection/list/'">
                          <img src="/img/PRODUTOS-TCG/TODOS_PRODUTOS.webp" class="img-fluid ms-2 h-50">
                        </a>
                      </div>

                      <div class="col-9 text-chumbo">
                        <h5 class="fw-bold fs-7 mb-0 ms-3"><a :href="'/collection/list/'">Todas as Coleções</a></h5>
                        <h6 class="mb-0 text-chumbo fs-7 ms-3"><a :href="'/collection/list/'">Clique aqui para ver todas as coleções disponíveis...</a></h6>
                      </div>
                      
                    </div>

                  </div>
                </div>

                <li class="active nav-item dropdown ms-4" @mouseover="() => {hideallless(), show_cards = true}" >
                  <a href="#" id="dropdownMenu1" data-bs-toggle="dropdown" aria-expanded="false" class="menu-hover">
                    <strong>CARDS</strong>
                    <span class="ms-2">
                      <img src="/img/newsIcons/SETA_CATEGORIAS.webp" alt="" style="width: 20px;"
                        class="dropdown-trigger mb-1">
                    </span>
                  </a>


                </li>
                <!-- Dropdown menu personalizado -->
                <div :class="show_cards ? 'show' : ''" @mouseleave="show_cards = false"
                  class="dropdown-menu p-3 border border-2 border-top-0 rounded-0 rounded-bottom m-auto w-100"
                  aria-labelledby="dropdownMenu1">
                  <div class="row">
                    <!-- Primeira coluna -->
                    <div
                      class="col-3 border-end border-secondary d-flex align-items-center justify-content-center cursor-pointer px-0 py-1"
                      @click="() => goToProductRank('product_stats.price_high')">
                      <img src="/img/newsIcons/CARDS_EM_ALTA.webp" alt="" style="height: 50px; width: auto;">
                      <div class="ms-3 text-chumbo">
                        <h5><strong>Cards em Alta</strong></h5>
                        <span class="text-truncate no-spacing fs-7">Acompanhe a
                          valorização</span>
                        <span class="no-spacing fs-7">das cartas na LIGA
                          BRA.</span>
                      </div>
                    </div>

                    <!-- Segunda coluna -->
                    <div
                      class="col-3 border-end border-secondary d-flex align-items-center justify-content-center cursor-pointer px-0 py-1"
                      @click="() => goToProductRank('product_stats.price_low')">
                      <img src="/img/newsIcons/CARDS_EM_BAIXA.webp" alt="" style="height: 50px; width: auto;">
                      <div class="ms-3 text-chumbo">
                        <h5><strong>Cards em Baixa</strong></h5>
                        <span class="text-truncate no-spacing fs-7">Acompanhe a
                          valorização</span>
                        <span class="no-spacing fs-7">das cartas na LIGA
                          BRA.</span>
                      </div>
                    </div>

                    <!-- Terceira coluna -->
                    <div
                      class="col-3 border-end border-secondary d-flex align-items-center justify-content-center cursor-pointer px-0 py-1"
                      @click="() => goToProductRank('product_sales_stats.monthly_sales')">
                      <img src="/img/newsIcons/MAIS_VENDIDOS.webp" alt="" style="height: 50px; width: auto;">
                      <div class="ms-3 text-chumbo">
                        <h5><strong>Cards Mais Vendidos</strong></h5>
                        <span class="no-spacing fs-7">Acompanhe os cards</span>
                        <span class="no-spacing fs-7">mais vendidos na LIGA
                          BRA.</span>
                      </div>
                    </div>

                    <!-- Quarta coluna -->
                    <div class="col-3 d-flex align-items-center justify-content-center cursor-pointer px-0 py-1"
                      @click="() => goToProductRank('product_views_summaries.monthly_views')">
                      <img src="/img/newsIcons/CADS_MAIS_VISTOS.webp" alt="" style="height: 38px; width: auto;">
                      <div class="ms-3 text-chumbo">
                        <h5><strong>Cards Mais Vistos</strong></h5>
                        <span class="no-spacing fs-7">Acompanhe os cards</span>
                        <span class="no-spacing fs-7">mais vistos na LIGA
                          BRA.</span>
                      </div>
                    </div>
                  </div>
                </div>

                <li class="active nav-item dropdown ms-4" @mouseover="() => {hideallless(), show_tcg = true}">
                  <a href="#" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false" class="menu-hover">
                    <strong>Produtos TCG</strong>
                    <span class="ms-2">
                      <img src="/img/newsIcons/SETA_CATEGORIAS.webp" alt="" style="width: 20px;"
                        class="dropdown-trigger mb-1">
                    </span>
                  </a>


                </li>
                <!-- Dropdown menu personalizado -->
                <div :class="show_tcg ? 'show' : ''" @mouseleave="show_tcg = false"
                  class="dropdown-menu border border-2 border-top-0 rounded-0 rounded-bottom py-0 m-auto w-100"
                  aria-labelledby="dropdownMenu2">
                  <div class="row">


                    <!--Primeira linha-->
                    <div class="col-20 row d-flex align-items-center justify-content-center border border-1 border-light p-1 h-auto py-2">
                      <div class="col-3 p-2">
                        <img src="/img/PRODUTOS-TCG/CAIXAS_BOOSTERS.webp" class="img-fluid ms-1" style="width: 90%; margin-top: -5px;">
                      </div>
                      <div class="col-9 text-chumbo">
                        <h6 class="mb-0 small fs-7 fw-bold" >Caixa de Boosters</h6>
                        <h6 class="mb-0 text-chumbo font-justify">Caixas que contêm</h6>
                        <h6 class="mb-0 text-chumbo font-justify">36 boosters.</h6>

                      </div>
                    </div>

                    <!-- Substituindo os ícones por imagens reais -->
                    <div class="col-20 d-flex align-items-center justify-content-center border border-1 border-light p-1 h-auto py-2">
                      <div class="col-3 p-2">
                        <img src="/img/PRODUTOS-TCG/CAIXA_TREINADOR_AVANCADO.png" class="img-fluid">
                      </div>
                      <div class="col-9 text-chumbo">
                        <h6 class="mb-0 small fs-7 fw-bold">Caixa Treinador Avançado</h6>
                        <h6 class="mb-0 font-justify">Caixa contendo carta promocional, sleeves, contadores de
                          dano, etc.</h6>
                      </div>
                    </div>

                    <div class="col-20 d-flex align-items-center justify-content-center border border-1 border-light p-1 h-auto py-2">
                      <div class="col-3 p-2">
                        <img src="/img/PRODUTOS-TCG/BOX_COLECIONAVEL.webp" class="img-fluid">
                      </div>
                      <div class="col-9 text-chumbo">
                        <h6 class="mb-0 small fs-7 fw-bold">Box Colecionável</h6>
                        <h6 class="mb-0 text-chumbo font-justify">Box contendo bossters, carta promocional e muito mais.</h6>
                      </div>
                    </div>

                    <div class="col-20 d-flex align-items-center justify-content-center border border-1 border-light p-1 h-auto py-2">
                      <div class="col-3 p-2">
                        <img src="/img/PRODUTOS-TCG/BLISTERS.webp" class="img-fluid">
                      </div>
                      <div class="col-9 text-chumbo ms-1">
                        <h6 class="mb-0 small fs-7 fw-bold">Blisters</h6>
                        <h6 class="mb-0 text-chumbo" style="font-size: 9.3px;">Um Bosster unitário com uma embalagem de papelão em volta.</h6>
                      </div>
                    </div>

                    <div class="col-20 d-flex align-items-center justify-content-center border border-1 border-light p-1 h-auto py-2">
                      <div class="col-3 p-2">
                        <img src="/img/PRODUTOS-TCG/MINI_BOOSTER.png" class="img-fluid w-75">
                      </div>
                      <div class="col-9 text-chumbo">
                        <h6 class="mb-0 small fs-7 fw-bold">Mini Boosters</h6>
                        <h6 class="mb-0 text-chumbo font-justify">Caixas que contêm</h6>
                        <h6 class="mb-0 text-chumbo font-justify">18 boosters.</h6>

                      </div>
                    </div>

                    <!-- Segunda linha -->
                    <div class="col-20 d-flex align-items-center justify-content-center border border-1 border-light p-1 h-auto py-2">
                      <div class="col-3 p-2 ms-3">
                        <img src="/img/PRODUTOS-TCG/BOOSTERS_AVULSOS.webp" class="img-fluid ms-1" style="width: 65%">
                      </div>
                      <div class="col-9 text-chumbo ms-1">
                        <h5 class="mb-0 small fs-7 fw-bold mt-1">Boosters Avulsos</h5>
                        <h6 class="mb-0 text-chumbo font-justify">Boosters são pacotes de cartas de determinada edição.</h6>
                      </div>
                    </div>

                    <div class="col-20 d-flex align-items-center justify-content-center border border-1 border-light p-1 h-auto py-2">
                      <div class="col-3">
                        <img src="/img/PRODUTOS-TCG/DECKS_PRONTOS.webp" class="img-fluid w-75 ms-2">
                      </div>
                      <div class="col-9 text-chumbo" style="margin-top: -10px;">
                        <h6 class="mb-0 small fs-7 fw-bold">Decks Prontos</h6>
                        <h6 class="mb-0 text-chumbo font-justify">Decks completos de 60 cartas.</h6>
                      </div>
                    </div>

                    <div class="col-20 d-flex align-items-center justify-content-center border border-1 border-light p-1 h-auto py-2">
                      <div class="col-3 p-2">
                        <img src="/img/PRODUTOS-TCG/DESAFIO_ESTRATEGICO.webp" class="img-fluid w-75 ms-1">
                      </div>
                      <div class="col-9 text-chumbo mt-1">
                        <h6 class="mb-0 small fs-7 fw-bold" style="margin-top: -14px;">Desafio Estratégico</h6>
                        <h6 class="mb-0 text-chumbo font-justify">Kit de cartas colecionáveis.</h6>
                      </div>
                    </div>

                    <div class="col-20 d-flex align-items-center justify-content-center border border-1 border-light p-1 h-auto py-2">
                      <div class="col-3">
                        <img src="/img/PRODUTOS-TCG/PRODUTOS_ESPECIAIS.png" class="img-fluid ms-2" style="width: 90%">
                      </div>
                      <div class="col-9 text-chumbo ms-1">
                        <h6 class="mb-0 small fs-7 fw-bold">Produtos Especiais</h6>
                        <h6 class="mb-0 text-chumbo" style="font-size: 9.3px;">Cartas holográficas promocionais com textura especial.
                        </h6>
                      </div>
                    </div>

                    <div class="col-20 d-flex align-items-center justify-content-center border border-1 border-light p-1 h-auto py-2">
                      <div class="col-3 p-2">
                        <a :href="'/producttcg/list/'">
                          <img src="/img/PRODUTOS-TCG/TODOS_PRODUTOS.webp" class="img-fluid">
                        </a>
                      </div>

                      <div class="col-9 text-chumbo">
                        <h6 class="mb-0 small fs-7 fw-bold"><a :href="'/producttcg/list/'">Outros Produtos</a></h6>
                        <h6 class="mb-0 text-chumbo font-justify"><a :href="'/producttcg/list/'">Clique aqui para ver <br>outros produtos</a></h6>
                      </div>
                    </div>
                  </div>

                </div>

                <li class="active ms-4">
                  <a href="/classifieds">
                    Classificados
                  </a>
                </li>
                <li class="active ms-4">
                  <a href="/products-cards-bra-center">
                    BRA CENTER
                  </a>
                </li>

                <li class="active ms-4">
                  <a href="/my-store/besaler">
                    SEJA UM LOJISTA
                  </a>
                </li>

                <li class="active nav-item dropdown ms-4" @mouseover="() => {hideallless(), show_ligas = true}" >
                  <a href="#" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false" class="menu-hover">
                    <strong>LIGAS</strong>
                    <span class="ms-2">
                      <img src="/img/newsIcons/SETA_CATEGORIAS.webp" alt="" style="width: 20px;"
                        class="dropdown-trigger mb-1">
                    </span>
                  </a>


                </li>
                <!-- Dropdown menu personalizado -->
                <div :class="show_ligas ? 'show' : ''" @mouseleave="show_ligas = false"
                  class="dropdown-menu p-3 border border-2 border-top-0 rounded-0 rounded-bottom m-auto w-100"
                  aria-labelledby="dropdownMenu2">
                  <div class="row">
                    <!-- Primeira coluna -->
                    <div
                      class="col-2 border-end border-secondary d-flex align-items-center justify-content-center cursor-pointer px-4"
                      @click="() => goToLeague('pokemon')">
                      <img class="img-fluid" src="/img/LOGOS/pokemon.png" alt="">
                    </div>

                    <!-- Segunda coluna -->
                    <div
                      class="col-2 border-end border-secondary d-flex align-items-center justify-content-center cursor-pointer px-4"
                      @click="() => goToLeague('lorcana')">
                      <img class="img-fluid" src="/img/LOGOS/Disney_Lorcana_TCG_Logo_transparent.png" alt="">
                    </div>

                    <!-- Terceira coluna -->
                    <div
                      class="col-2 border-end border-secondary d-flex align-items-center justify-content-center cursor-pointer px-4"
                      @click="() => goToLeague('magic')">
                      <img class="img-fluid" src="/img/LOGOS/magic_the_gathering.png" alt="">
                    </div>

                    <!-- Quarta coluna -->
                    <div
                      class="col-2 border-end border-secondary d-flex align-items-center justify-content-center cursor-pointer px-4"
                      @click="() => goToLeague('yugioh')">
                      <img class="img-fluid" src="/img/LOGOS/yu_gi_oh.png" alt="">
                    </div>

                    <!-- Quinta coluna -->
                    <div
                      class="col-2 border-end border-secondary d-flex align-items-center justify-content-center cursor-pointer px-4"
                      @click="() => goToLeague('onepiece')">
                      <img class="img-fluid" src="/img/LOGOS/One_Piece.png" alt="">
                    </div>

                    <!-- Sexta coluna -->
                    <div class="col-2 d-flex align-items-center justify-content-center cursor-pointer px-4"
                      @click="() => goToLeague('naruto')">
                        <img class="img-fluid" src="/img/LOGOS/Naruto_logo.png" alt="">
                    </div>

                  </div>
                </div>

                <li class="ms-3">
                  <div class="mt-3">
                    <img class="ms-3" src="/img/BANDEIRAS/BRASIL.webp" alt="" style="width: 40px;">
                    <img class="ms-3" src="/img/BANDEIRAS/EUA.webp" alt="" style="width: 40px;">
                    <img class="ms-3" src="/img/BANDEIRAS/JAPAO.webp" alt="" style="width: 40px;">
                  </div>
                </li>

                <!--<li class="active">
                  <router-link :to="getLinkHref2('Question')">
                    Dúvidas frequentes
                  </router-link>
                </li>
                
                <li class="active">
                  <a :href="getLinkHref()">
                    Lista de acompanhamento
                  </a>
                </li>
                <li class="active">
                  <router-link :to="getLinkHref2('Shopkeeper')">
                    Vire um lojista
                  </router-link>
                </li>-->
              </ul>
            </nav>

          </div>

          <!-- Menu Mobile 
          <div class="mobile-menu">
            <div class="categories_title_mobile" @click="toggleMobileMenu">
              <h4 class="categori_toggle ms-1 text-white">
                Categorias
                <span class="toggle-icon float-end" style="margin-right: 12px; margin-top: -3px;">
                  <i class="fa fa-bars fs-1"></i>
                </span>
              </h4>
            </div>
            <div v-if="isMobileMenuOpen" class="categories_menu_mobile_toggle">
              <span class="float-end" style="margin-top: -10px;" @click="toggleMobileMenu">
                <i class="fa fa-close" style="font-size: 16px;"></i>
              </span>
              <ul v-for="category in categories" :key="category.id">
                <li class="menu_item_children categorie_list">
                  <a :href="'/product/list/' + category.id">{{ category.name }}</a>

                  <span class="ms-2" v-if="category.child_category.length" @click="toggleCategory(category.id)">
                    <i :class="openCategoryId === category.id ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
                  </span>

                  <div v-if="openCategoryId === category.id" class="grandchild_card">
                    <ul>
                      <li v-for="child_category in category.child_category" :key="child_category.id">
                        <a :href="'/product/list/' + child_category.id">{{ child_category.name }}</a>

                        <span class="ms-2" v-if="child_category.child_category.length"
                          @click="toggleGrandChild(category.id, child_category.id)">
                          <i
                            :class="openCategoryId === category.id && openChildCategoryId === child_category.id ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
                        </span>

                        <div v-if="openCategoryId === category.id && openChildCategoryId === child_category.id"
                          class="grandchild_card">
                          <ul>
                            <li v-for="grandChild in child_category.child_category" :key="grandChild.id">
                              <a :href="'/product/list/' + grandChild.id">{{ grandChild.name }}</a>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>

                </li>
              </ul>
            </div>
          </div>-->

        </div>
        <!--<div class="col-lg-9">
          
        </div>-->

      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isMobileMenuOpen: false, // Initially, mobile menu is closed
      openCategoryId: null,    // To track the open parent category
      openChildCategoryId: null,
      show_collection: false,
      show_cards: false,
      show_tcg: false,
      show_ligas: false
    };
  },
  mounted() {
    console.log(this.user, "user")
  },
  methods: {
    hideallless(){
      this.show_collection = false;
      this.show_cards = false;
      this.show_tcg = false;
      this.show_ligas = false;
    },
    toggleMobileMenu() {
    },
    navigateToHome(category) {
      // event.preventDefault(); // Impede qualquer comportamento inesperado
      if (category.code === 'cards') {
        window.location.href = "/collection/list";
      } else if (category.code === 'tcg') {
        window.location.href = "/product/list/" + category.id;
      }

    },
    goToProductRank(type) {
      // this.$router.push({ name: 'show_product_rank', params: { type } });
      window.location.href = "/product/rank/" + type;
    },
    getLinkHref() {
      const baseUrl = window.location.origin; // Obtém a base URL completa
      if (this.user) {
        return `${baseUrl}/favorite/list`; // Garante a URL completa para a lista de favoritos
      } else {
        return `${baseUrl}/auth/login`; // Garante a URL completa para o login
      }
    },
    getLinkHref2(routeName) {
      return { name: routeName };
    },
    goToLeague(name) {
      window.location.href = `/league/${name}`;
    },
    toggleSubMenu(child_category) {
      if (this.openSubMenu && this.openSubMenu !== child_category) {
        this.openSubMenu.showSubMenu = false;
      }
      child_category.showSubMenu = !child_category.showSubMenu;
      this.openSubMenu = child_category.showSubMenu ? child_category : null;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen; // Toggle the mobile menu visibility
    },
    toggleCategory(categoryId) {
      // Alterna entre abrir/fechar subcategorias
      this.openCategoryId = this.openCategoryId === categoryId ? null : categoryId;
      // Se a categoria principal for aberta, também fecha as subcategorias abertas
      if (this.openCategoryId === categoryId) {
        this.openChildCategoryId = null;
      }
    },
    toggleGrandChild(categoryId, childCategoryId) {
      // Alterna entre abrir/fechar sub-subcategorias
      if (this.openCategoryId === categoryId && this.openChildCategoryId === childCategoryId) {
        this.openChildCategoryId = null;
      } else {
        this.openChildCategoryId = childCategoryId;
      }
    },
    keepSubMenuOpen() {
      console.log('sou keepSubMenuOpen');
    },
    closeAllSubMenus() {
      if (this.openSubMenu) {
        this.openSubMenu.showSubMenu = false;
      }
    },
  },
  computed: {
    collection_categories() {
      return this.$store.state.category.collection_categories;
    },

    tcg_categories() {
      return this.$store.state.category.tcg_categories;
    },
    user() {
      return this.$store.state.user.current_user;
    },
  },
  beforeCreate() {
    // this.$store.dispatch("category/get_categories");
  },
};
</script>

<style>
.no-spacing {
  margin-top: -10px !important;
  padding: 0;
  display: block;
  /* ou inline-block, dependendo do seu layout */
}

/* Inicialmente, as subcategorias estão ocultas */
.categories_mega_menu {
  display: none;
  /* Inicialmente as subcategorias estão ocultas */
  position: absolute;
  background-color: white;
  border: 1px solid #ddd;
  padding: 10px;
  z-index: 10;
  width: 800px;
  /* Ajuste o tamanho conforme necessário */
  flex-wrap: wrap;
  /* Permite quebrar para uma nova linha quando necessário */
}

.menu_item_children:hover .categories_mega_menu {
  display: flex;
  /* Exibe as subcategorias ao passar o mouse */
  flex-wrap: wrap;
  /* Isso vai quebrar as subcategorias em linhas */
}

/* Cada item de subcategoria ocupará 33% do contêiner (3 itens por linha) */
.menu_item_children .categories_mega_menu li {
  width: 33.33%;
  /* Cada item ocupará 1/3 da largura */
  box-sizing: border-box;
  /* Para garantir que o padding seja considerado no cálculo do tamanho */
  padding: 5px;
  /* Ajuste o padding se necessário */
  display: inline-block;
}

/* Sub-subcategorias (se houver) */
.grandchild_mega_menu {
  display: none;
  /* Inicialmente, as sub-subcategorias estão ocultas */
  position: absolute;
  background-color: white;
  border: 1px solid #ddd;
  padding: 10px;
}

.menu_item_children:hover .grandchild_mega_menu {
  display: block;
  /* Exibe as sub-subcategorias ao passar o mouse sobre a subcategoria */
}

/* Mobile Menu Styles */
.categories_menu_mobile_toggle {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: white;
  padding: 20px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  border-radius: 10px;
  margin: 10px;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: 40%;
}

/* The mobile-menu container itself is already styled to be hidden/shown in media queries */
.mobile-menu {
  display: none;
  background-color: #2e67ae;
  padding: 10px;
  margin-bottom: 10%;
}

.categories_title_mobile {
  cursor: pointer;
}

.grandchild_card {
  background-color: #fff;
  border: 1px solid #ddd;
  padding: 10px;
  margin-top: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.menu-hover:hover {
  background-color: #ebebeb;
  color: #2e67ae;
  border-left: 2px solid #2e67ae;

}

.dropdown:hover .dropdown-menu {
  display: block;
}

.dropdown-menu {
  background-color: #ebebeb;
}

.font-justify {
  font-size: 9.3px;
}

@media (max-width: 767px) {
  .desktop-menu {
    display: none;
  }

  .mobile-menu {
    display: block;
  }
}

/* Hide the mobile menu on larger screens */
@media (min-width: 768px) {
  .mobile-menu {
    display: none;
  }

  .desktop-menu {
    display: block;
  }
}
</style>
